import { PromotionContextProvider } from "src/contexts/promotion.context";
import { PromoWrapper } from "./ProductList.styled";
import { BrandsPromo } from "src/molecules/BrandsPromo";
import { useState } from "react";
import NoSSR from "src/atoms/NoSSR";

function Promotion({ slug }: { slug: string }): JSX.Element | null {
  const [displayPromo, setDisplayPromo] = useState(true);

  if (!displayPromo) {
    return null;
  }

  return (
    <NoSSR>
      <PromoWrapper>
        <PromotionContextProvider>
          <BrandsPromo slug={slug} callback={setDisplayPromo} />
        </PromotionContextProvider>
      </PromoWrapper>
    </NoSSR>
  );
}

export { Promotion };
